import { IntentStatuses } from '@/types'
import type { LinkedEntityType } from '@/types'

export function getLinkedEntityLabel(type: LinkedEntityType | null): string | null {
  switch (type) {
    case 'WorkItem': return 'Work Item'
    case 'Intent': return 'Intent'
    case 'Project': return 'Project'
    default: return null
  }
}

export function getLinkedEntityPrefix(type: LinkedEntityType | null): string | null {
  switch (type) {
    case 'WorkItem': return 'WI-'
    case 'Intent': return 'INT-'
    default: return null
  }
}

const INTENT_STATUSES: readonly string[] = Object.values(IntentStatuses)

export function resolveLinkedEntityType(
  type: LinkedEntityType | null,
  status?: string | null,
): LinkedEntityType | null {
  return type === 'Intent' && status && !INTENT_STATUSES.includes(status) ? 'WorkItem' : type
}

export function getLinkedEntityPath(
  projectId: string,
  type: LinkedEntityType | null,
  entityId: string,
): string | null {
  switch (type) {
    case 'WorkItem': return `/projects/${projectId}/backlog?workItemId=${entityId}`
    case 'Intent': return `/projects/${projectId}/intents?intentId=${entityId}`
    case 'Project': return `/projects/${projectId}/overview`
    default: return null
  }
}

export function getLinkedEntityShortId(
  type: LinkedEntityType | null,
  num: number | null | undefined,
): string | null {
  const prefix = getLinkedEntityPrefix(type)
  if (prefix === null || num === null || num === undefined) return null
  return `${prefix}${num}`
}
